import React, { useState, useEffect } from 'react';
import AlertBox, { Heading } from 'components/shared/AlertBox';
import { Button, ButtonGroup } from 'components/ui';

const ConfirmDeleteModal = ({ onDismiss, handleDelete, userResponseId }) => {
  const [disabledDeleteButton, setDisabledDeleteButton] = useState(false);

  useEffect(
    () => () => {
      setDisabledDeleteButton(false);
    },
    [setDisabledDeleteButton],
  );

  return (
    <AlertBox onDismiss={onDismiss} className="MyResponsesTab--modal">
      <Heading>{t('practice.on_demand_practice.confirm_delete.title')}</Heading>
      {t('practice.on_demand_practice.confirm_delete.description')}
      <ButtonGroup alignEnd className="mt-8">
        <Button
          customColor
          onClick={() => {
            setDisabledDeleteButton(true);
            handleDelete(userResponseId);
          }}
          className="PreviousAttempt-confirmDelete"
          disabled={disabledDeleteButton}
        >
          {t('common.delete')}
        </Button>
        <Button onClick={onDismiss}>{t('common.cancel')}</Button>
      </ButtonGroup>
    </AlertBox>
  );
};

export default ConfirmDeleteModal;
